import { Component } from '@angular/core';
import { ShoppingCartService } from '../../services/shopping-cart.service';
import { Router, Route, ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-shopping-cart',
    template: `
    <div id="shopping-cart">
      <button class="btn btn-general-light " [disabled]="shoppingCartSize() == 0" (click)="checkout()">
        {{ 'event-list.checkout' | translate }}
        <clr-icon shape="shopping-cart"  [ngClass]="{'has-badge': shoppingCartSize() != 0}"></clr-icon>
        {{shoppingCartService.tickets.length}}
      </button>
    </div>
    `,
    styleUrls: ['./shopping-cart.scss']
})
export class ShoppingCartComponent {
    constructor(
      private _router: Router,
      private _route: ActivatedRoute,
      public shoppingCartService: ShoppingCartService) {}
    shoppingCartSize() {
        return this.shoppingCartService.size;
      }
    checkout() {
        // noinspection JSIgnoredPromiseFromCall
        this._router.navigate([
          this._route.snapshot.params['username'], 'checkout'
        ]);
      }

}
